import React from 'react'
import {Link} from "react-router-dom";


export default function Dept(props) {
 
    return (
      <>
    <div className='container my-4 text-center'  >
            <h1>{props.title}, AUS</h1>
            <div className="col d-flex justify-content-center my-4">
              <div className="card my-3"  style= {{width: "23rem"}}>
                  <img src={props.img}  className="card-img-top" alt="this is img"/>
                  <div className="card-body">
                      <h4 className="card-title">Course Structure/Syllabus</h4>
                      <h6 className="card-text">Syllabus of the 4 years {props.dept} B.Tech course of School of Technology, Assam University,Silchar.</h6>
                      
                      <Link to= {props.syllabus} className="btn btn-primary" target="blank" >Preview/Download</Link>
                  </div>
              </div>
            </div>
        </div>
       
    </>
  );
}

